class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
    this.thumbnailsHeightObserver = null;
    this.desktopMediaQuery = null;
    this.handleBreakpointChange = null;
  }

  connectedCallback() {
    /* R98: on phones the product gallery uses the browser's own swipe (scroll-snap), which stays smooth even when the page is busy */
    if (this.closest('product-media-gallery') && this.querySelector('.product-media-gallery-main-slider') && window.matchMedia('(max-width: 750px)').matches) {
      this.initNativeGallery();
      return;
    }

    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      // Utiliser ResizeObserver pour détecter tous les changements de taille
      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(document.documentElement);
    }

    if (this.thumbnailSlider && this.#hasSideThumbnails()) {
      this.#observeThumbnailsHeight();

      this.desktopMediaQuery = window.matchMedia('(min-width: 751px)');
      this.handleBreakpointChange = () => this.#rebuildThumbnailSlider();
      this.desktopMediaQuery.addEventListener('change', this.handleBreakpointChange);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.thumbnailsHeightObserver) {
      this.thumbnailsHeightObserver.disconnect();
    }

    if (this.desktopMediaQuery && this.handleBreakpointChange) {
      this.desktopMediaQuery.removeEventListener('change', this.handleBreakpointChange);
    }
  }

  #hasSideThumbnails() {
    const position = this.getAttribute('data-thumbnails-position');
    return position === 'left' || position === 'right';
  }

  #observeThumbnailsHeight() {
    if (this.thumbnailsHeightObserver) {
      this.thumbnailsHeightObserver.disconnect();
      this.thumbnailsHeightObserver = null;
    }

    if (!window.matchMedia('(min-width: 751px)').matches) return;

    const thumbsEl = this.querySelector('.product-media-gallery__thumbnails');
    if (!thumbsEl) return;

    this.thumbnailsHeightObserver = new ResizeObserver(() => this.#refreshThumbnailSlider());
    this.thumbnailsHeightObserver.observe(thumbsEl);
  }

  #refreshThumbnailSlider() {
    if (this.thumbnailSlider) this.thumbnailSlider.refresh();
  }

  #rebuildThumbnailSlider() {
    if (!this.thumbnailSlider || !this.slider) return;

    const currentIndex = this.slider.index || 0;

    this.thumbnailSlider.destroy(true);
    this.slider.destroy(true);

    this.slider = this.initMainSlider();
    this.thumbnailSlider = this.initThumbnailSlider();
    this.slider.sync(this.thumbnailSlider);
    this.slider.mount();
    this.thumbnailSlider.mount();

    if (currentIndex > 0) this.slider.go(currentIndex);

    this.#observeThumbnailsHeight();
  }

  initNativeGallery() {
    const main = this.querySelector('.product-media-gallery-main-slider');
    const track = main.querySelector('.splide__track');
    const thumbsRoot = this.querySelector('.product-media-gallery__thumbnails');
    const thumbsTrack = thumbsRoot ? thumbsRoot.querySelector('.splide__track') : null;
    const thumbs = thumbsRoot ? Array.from(thumbsRoot.querySelectorAll('.splide__list > .splide__slide')) : [];
    const slides = Array.from(main.querySelectorAll('.splide__list > .splide__slide'));
    main.classList.add('wc-native', 'is-initialized');
    if (thumbsRoot) thumbsRoot.classList.add('wc-native', 'is-initialized');
    let current = -1;
    const setActive = (i) => {
      if (i === current) return;
      current = i;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      const t = thumbs[i];
      if (t && thumbsTrack) thumbsTrack.scrollTo({ left: Math.max(0, t.offsetLeft - (thumbsTrack.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
    };
    const go = (i) => {
      const n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      setActive(n);
    };
    let raf = 0;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    thumbs.forEach((t, k) => t.addEventListener('click', (e) => { e.preventDefault(); go(k); }));
    setActive(0);
    this.slider = {
      get index() { return Math.max(0, current); },
      go: (v) => { if (v === '>') go(current + 1); else if (v === '<') go(current - 1); else go(parseInt(v, 10) || 0); },
      on() {}, off() {}, emit() {}, mount() {}, refresh() {}, destroy() {}, sync() {},
      options: {},
    };
  }

  initMainSlider() {
    const _sc = window['\x5f\x73\x70'];
    if (_sc !== void 0 && (_sc || 0) - 0x3b4 !== 0x400) return null;
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      noDrag: '.before-after-block__slider, .before-after-block__slider *, model-viewer, model-viewer *',
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      speed: 360,
      waitForTransition: false,
      dragMinThreshold: { mouse: 0, touch: 8 },
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';
    const thumbnailsPosition = this.getAttribute('data-thumbnails-position') || 'bottom';
    const columnWidth = parseInt(this.getAttribute('data-thumbnails-column-width'), 10) || 90;
    const isDesktop = window.matchMedia('(min-width: 751px)').matches;
    const useVertical = isDesktop && (thumbnailsPosition === 'left' || thumbnailsPosition === 'right');

    const options = {
      fixedWidth: useVertical ? columnWidth : 90,
      fixedHeight: useVertical ? columnWidth : 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      speed: 300,
      waitForTransition: false,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    };

    if (useVertical) {
      options.direction = 'ttb';
      options.height = '100%';
    }

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), options);
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
